import axios from 'axios'

import { DEFAULT_REQUEST_CONFIG } from '@/legacy/config/request'

export const request = axios.create({
  baseURL: process.env.NEXT_PUBLIC_HOST,
  ...DEFAULT_REQUEST_CONFIG,
})
